import React, { FC } from 'react'
import { useFormikContext } from 'formik'

import { FormFieldSelectProps } from '../form/fields/FormFieldSelect'
import { FormFieldInputProps } from '../form/fields/FormFieldInput'
import FormikField from '../form/FormikField'
import { FormFieldToggleButtonGroupProps } from '../form/fields/FormFieldToggleButtonGroup'
import { OTHER_FAMILY_RELATIONSHIP } from '../../relay/Declaration/Steps/useAddMemberStep'

import * as SC from './styled'

export type DeclarationAddMemberProps = {
  className?: string
  displayFields?: boolean
  description?: string
  fields: {
    hasMemberToDeclare: FormFieldToggleButtonGroupProps
    civility: FormFieldSelectProps
    lastName: FormFieldInputProps
    firstName: FormFieldInputProps
    familyRelationshipId?: FormFieldSelectProps
    familyRelationshipCustom?: FormFieldInputProps
  }
}

const FamilyRelationshipCustom: FC<{ field: FormFieldInputProps }> = ({ field }) => {
  const { values } = useFormikContext<{ familyRelationshipId?: string }>()

  if (values?.familyRelationshipId !== OTHER_FAMILY_RELATIONSHIP) {
    return null
  }

  return <FormikField {...field} Component={SC.Input} />
}

const DeclarationAddMember: FC<DeclarationAddMemberProps> = (props) => {
  const { className, fields, displayFields = true, description } = props

  return (
    <SC.Container className={className}>
      {description && <SC.Description>{description}</SC.Description>}
      <FormikField {...fields.hasMemberToDeclare} Component={SC.ToggleGroup} />
      {displayFields ? (
        <SC.Inputs>
          {fields.civility && <FormikField {...fields.civility} Component={SC.Select} />}
          {fields.lastName && <FormikField {...fields.lastName} Component={SC.Input} />}
          {fields.firstName && <FormikField {...fields.firstName} Component={SC.Input} />}
          {fields.familyRelationshipId && (
            <SC.RelationshipRow>
              <FormikField {...fields.familyRelationshipId} Component={SC.RelationshipSelect} />
              {fields.familyRelationshipCustom && (
                <FamilyRelationshipCustom field={fields.familyRelationshipCustom} />
              )}
            </SC.RelationshipRow>
          )}
        </SC.Inputs>
      ) : null}
    </SC.Container>
  )
}

export default DeclarationAddMember
